import { Component, h, Prop, Element, Method, Fragment } from '@stencil/core';
import { trans } from '../../../../utils/trans';
import { FormRenderProps, FormValues } from "../../../stencil-form/declarations";

@Component({
    tag: 'rentware-checkout-data-form-template',
    styleUrl: 'rentware-checkout-data-form-template.sass',
    shadow: true,
})
export class RentwareCheckoutDataFormTemplate {
    @Prop() dataForm;
    @Prop() locale: string;
    @Prop() translations;
    @Prop() submitDataForm;
    @Prop() renderDataFormFields;
    @Prop() formData;
    @Prop() dataFormFormRef;
    @Prop() onFormValid;
    @Prop() currentStep;
    @Prop() errors;
    @Prop() isSavingDataForm;
    @Prop() isWaiting: boolean;
    @Prop() onValueChange;


    @Element() el;

    @Method()
    async goToFirstError() {
        this.goToError();
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        const values = e.detail.values;
        this.submitDataForm.emit(values);
    }

  handleValueChange= (e) => {
    e.preventDefault();
    if (!e.detail || !Array.isArray(e.detail)) {
      return
    }

    const [fieldName, value] = e.detail;

    this.onValueChange([fieldName, value]);
  }

    componentDidLoad() {
        if (this.errors?.some(error => error.stepId === this.currentStep.id)) {
            this.goToError();
        }
    }

    goToError = () => {
        this.el.shadowRoot.querySelector(".has-error")?.scrollIntoView({ behavior: 'smooth' });
    }

    formTemplate = (props: FormRenderProps<FormValues>) => {
        return (
            <Fragment>
                <rentware-spacer size="S" />

                <div class="FieldsContainerFlex">
                    {this.renderDataFormFields(props)}
                </div>
            </Fragment>
        )
    }

    render() {
        return (
            <div class="DataFormContainer">
                {this.dataForm.dataForms[0].fields.find((field) => field.type === "file") && this.isSavingDataForm &&
                    <div class="spinnerContainer">
                        <rentware-spinner />
                        <div class="spinnerText">
                            <rentware-spacer size="S" />
                            {trans('dataForms.uploadingFiles', this.locale, this.translations)}
                        </div>
                    </div>
                }

                <div class="DataFormContainerInner">
                    <rentware-spacer-m class="MobileOnly" />
                    <rentware-spacer size="S" />

                    <stencil-form
                        ref={(el) => this.dataFormFormRef(el)}
                        initialValues={this.dataForm.values}
                        onFormSubmit={(e) => this.onFormSubmit(e)}
                        onValueChange={(e) => this.handleValueChange(e)}
                        validateOnInput={true}
                        onFormValid={this.onFormValid}
                        renderer={this.formTemplate}
                    />
                    <rentware-spacer size="M" />
                    {this.isWaiting && <rentware-spinner-squares />}
                  
                    {/* Big spacer below is required to make all inputs in data-form visible (otherwise a footer action bar is covering it)*/}
                    <rentware-spacer size="XL" />
                    <rentware-spacer size="XL" />
                </div>
            </div>
        )
    }
}
